export const BRAND = {
    name: "Eway Fiber Net",
    shortName: "EWAY",
    tagline: "High-Speed Internet – Ultimate Value",
    trustLine: "Trusted by NRT’ians Since 15+ Years",
    phones: [
        { label: "89777 71326", raw: "8977771326", tel: "tel:+918977771326" },
        { label: "91777 71326", raw: "9177771326", tel: "tel:+919177771326" },
    ],
    whatsapp: "https://wa.me/918977771326",
    careHours: "10:00 AM – 8:00 PM",
    careHoursShort: "10 AM – 8 PM",
    location: "Narasaraopet, Andhra Pradesh",
    links: {
        customerPortal: "https://user.ewayfibernet.in/",
        // VERIFIED official Paytm provider page — serves "Eway FiberNet – Make Instant
        // Eway FiberNet Bill Payment" with the operator bill form (User ID → Get Bill).
        // To change the payment destination, update this one value.
        payNow: "https://paytm.com/broadband-bill-payment/eway-fibernet",
    },
};

export const NAV_LINKS = [
    { to: "/", label: "Home", id: "home" },
    { to: "/plans", label: "Plans", id: "plans" },
    { to: "/ott", label: "OTT & TV", id: "ott" },
    { to: "/why-eway", label: "Why Eway", id: "why-eway" },
    { to: "/about", label: "About Us", id: "about" },
    { to: "/support", label: "Support", id: "support" },
    { to: "/contact", label: "Contact", id: "contact" },
];

export const PLANS = [
    {
        id: "30",
        speed: 30,
        monthly: 350,
        installation: 600,
        sixNoRouter: 1800,
        sixRouter: 2400,
        highlight: false,
        tag: "STARTER",
        blurb: "Everyday browsing, online classes & social media",
        benefits: [
            "True FTTH fiber to your home",
            "99.9% network uptime",
            "TV + OTT add-ons available",
            "Local customer support",
        ],
    },
    {
        id: "50",
        speed: 50,
        monthly: 590,
        installation: null,
        sixNoRouter: 2500,
        sixRouter: 3500,
        highlight: false,
        tag: "VALUE",
        blurb: "HD streaming & smooth work from home",
        benefits: [
            "True FTTH fiber to your home",
            "99.9% network uptime",
            "TV + OTT add-ons available",
            "Local customer support",
        ],
    },
    {
        id: "75",
        speed: 75,
        monthly: 750,
        installation: null,
        sixNoRouter: 3500,
        sixRouter: 4200,
        highlight: true,
        tag: "POPULAR",
        blurb: "4K streaming, gaming & busy families",
        benefits: [
            "High-speed FTTH for streaming & gaming",
            "99.9% network uptime",
            "TV + OTT add-ons available",
            "Priority local support",
        ],
    },
    {
        id: "100",
        speed: 100,
        monthly: 1000,
        installation: null,
        sixNoRouter: 4700,
        sixRouter: 5700,
        highlight: true,
        tag: "PREMIUM",
        blurb: "Ultimate speed for power users",
        benefits: [
            "Maximum FTTH speed tier",
            "99.9% network uptime",
            "TV + OTT add-ons available",
            "Priority local support",
        ],
    },
];

export const TV_CATEGORIES = [
    "Telugu",
    "Movies",
    "Series",
    "Sports",
    "Kids",
    "Entertainment",
    "News",
];

export const OTT_APPS = [
    { name: "Amazon Prime Video", letter: "P", color: "#00A8E1" },
    { name: "JioHotstar", letter: "H", color: "#1F80E0" },
    { name: "Aha", letter: "A", color: "#F5A623" },
    { name: "ZEE5", letter: "Z", color: "#8B5CF6" },
    { name: "SonyLIV", letter: "S", color: "#3B82F6" },
];

export const MARQUEE_ITEMS = [
    "99.9% UPTIME",
    "15+ YEARS OF TRUST",
    "HIGH-SPEED FTTH",
    "240+ LIVE TV CHANNELS",
    "14+ OTT APPS",
    "FREE TV FOR 3 MONTHS",
    "NARASARAOPET · ANDHRA PRADESH",
];

export const IMAGES = {
    heroFiber:
        "https://images.unsplash.com/photo-1604869515882-4d10fa4b0492?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxmaWJlciUyMG9wdGljJTIwY2FibGUlMjB0ZWNobm9sb2d5JTIwc3BlZWQlMjBjb25uZWN0aW9uJTIwaW50ZXJuZXQlMjBuZXR3b3JrfGVufDB8fHx8MTc5MTM1NjY4OHww&ixlib=rb-4.1.0&q=85",
    fiberPatch:
        "https://images.unsplash.com/photo-1683322499436-f4383dd59f5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxmaWJlciUyMG9wdGljJTIwY2FibGUlMjB0ZWNobm9sb2d5JTIwc3BlZWQlMjBjb25uZWN0aW9uJTIwaW50ZXJuZXQlMjBuZXR3b3JrfGVufDB8fHx8MTc5MTM1NjY4OHww&ixlib=rb-4.1.0&q=85",
    ethernet:
        "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxmaWJlciUyMG9wdGljJTIwY2FibGUlMjB0ZWNobm9sb2d5JTIwc3BlZWQlMjBjb25uZWN0aW9uJTIwaW50ZXJuZXQlMjBuZXR3b3JrfGVufDB8fHx8MTc5MTM1NjY4OHww&ixlib=rb-4.1.0&q=85",
    familyTv:
        "https://images.unsplash.com/photo-1613280194169-6bb2f32a6bfa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBmYW1pbHklMjBzdHJlYW1pbmclMjB0diUyMGVuam95aW5nJTIwaGlnaCUyMHNwZWVkJTIwaW50ZXJuZXQlMjBzbWFydCUyMHhvbWV8ZW58MHx8fHwxNzkxMzU2Njg4fDA&ixlib=rb-4.1.0&q=85",
    smartTv:
        "https://images.unsplash.com/photo-1767355272538-e7177d16f979?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBmYW1pbHklMjBzdHJlYW1pbmclMjB0diUyMGVuam95aW5nJTIwaGlnaCUyMHNwZWVkJTIwaW50ZXJuZXQlMjBzbWFydCUyMHhvbWV8ZW58MHx8fHwxNzkxMzU2Njg4fDA&ixlib=rb-4.1.0&q=85",
    remote:
        "https://images.unsplash.com/photo-1593784991188-c899ca07263b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBmYW1pbHklMjBzdHJlYW1pbmclMjB0diUyMGVuam95aW5nJTIwaGlnaCUyMHNwZWVkJTIwaW50ZXJuZXQlMjBzbWFydCUyMHhvbWV8ZW58MHx8fHwxNzkxMzU2Njg4fDA&ixlib=rb-4.1.0&q=85",
};

export const waLink = (message) =>
    `https://wa.me/918977771326?text=${encodeURIComponent(message)}`;
